import { render } from "./ImportadorView.vue?vue&type=template&id=f4b932cc&scoped=true"
import script from "./ImportadorView.vue?vue&type=script&lang=js"
export * from "./ImportadorView.vue?vue&type=script&lang=js"

import "./ImportadorView.vue?vue&type=style&index=0&id=f4b932cc&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b932cc"]])

export default __exports__